import angular from 'angular';

export default angular.module('helperModule', []);



// WEBPACK FOOTER //
// ./modules/helper/helper.module.js